import { Component, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, concat, of } from 'rxjs';
import { takeUntil, startWith, filter, debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';
import { UserApi } from 'src/app/core/api.gen';

@Component({
  selector: 'eos-type-ahead-select-employee',
  template: `
  <ng-select [items]="options$ | async"
      [notFoundText]="to.notFoundText"
      [placeholder]="to.placeholder"
      [typeahead]="searchInput$"
      bindLabel="name"
      [loading]="showLoader"
      [formControl]="formControl">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div><span>{{item.name}}</span></div>
      <div><span><small>{{item.email}}</small></span></div>
    </ng-template>
    </ng-select>
  `,
})

export class TypeAheadSelectEmployeeComponent extends FieldType implements OnDestroy {
  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  showLoader = false;

  constructor(private userService: UserApi) {
    super();
  }

  ngOnInit() {
    this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.showLoader = true),
        switchMap(term => this.userService.getEmployeesFilteredByRole(term, this.to.roles).pipe(
          catchError(() => of([])),
          tap(() => this.showLoader = false)
        ))
      )
    );
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
